import { ThreadedDemo } from "../ThreadedDemo";

export function DemoSection() {
  return (
    <section className="pb-20 px-2 md:px-6 bg-gradient-to-b from-white to-amber-50/50 border-b border-orange-200">
      <div className="max-w-4xl mx-auto">
        <ThreadedDemo />

        <p className="mt-4 text-center text-stone-600 text-sm md:text-base">
          👆 This demo is interactive! Try typing a request or clicking different channels
        </p>
      </div>
    </section>
  );
}
